// YourTicketsContent.jsx
import React, { useEffect, useRef, useState, useCallback } from 'react';
import TicketsList from './TicketsList';
import styles from './YourTicketsContent.module.css';
import backIcon from "../icons/back_icn.png";
import axios from 'axios';

const YourTicketsContent = ({ onBack, isAuthenticated, setIsAuthenticated }) => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);
  const [purchasedTickets, setPurchasedTickets] = useState([]);

  const fetchPurchasedTickets = useCallback(() => {
    if (isAuthenticated) {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setPurchasedTickets([]);
        return;
      }

      axios
        .get('/api/tickets/list', {
          headers:{ Authorization:`Bearer ${token}` },
        })
        .then((response) => {
          setPurchasedTickets(response.data);
        })
        .catch(() => {});
    } else {
      setPurchasedTickets([]);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchPurchasedTickets();

    window.addEventListener('purchasedTicketsChanged', fetchPurchasedTickets);

    return () => {
      window.removeEventListener('purchasedTicketsChanged', fetchPurchasedTickets);
    };
  }, [isAuthenticated, fetchPurchasedTickets]);

  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    const scrollStep = 1;
    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel',      stop, { passive:true });
      content.removeEventListener('touchstart', stop, { passive:true });
    };

    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel',      stop, { passive:true });
    content.addEventListener('touchstart', stop, { passive:true });

    return () => stop();
  }, []);

  const restartAutoScroll = () => {
    const content = contentRef.current;
    if (!content) return;

    clearInterval(scrollInterval.current);
    scrollInterval.current = null;

    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel',      stop, { passive:true });
      content.removeEventListener('touchstart', stop, { passive:true });
    };

    content.scrollTop = 0;
    const scrollStep = 1;
    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel',      stop, { passive:true });
    content.addEventListener('touchstart', stop, { passive:true });
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) { setIsAuthenticated(false); return; }

    axios
      .get('/api/users/verify-token', { headers:{ Authorization:`Bearer ${token}` } })
      .then(r => {
        if (r.data.valid) setIsAuthenticated(true);
        else {
          setIsAuthenticated(false);
          localStorage.removeItem('authToken');
          localStorage.removeItem('userId');
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userId');
      });
  }, [setIsAuthenticated]);

  return (
    <div className={styles.yourTicketsContentContainer}>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />
      <h1 className={styles.pageTitle}>Мої квитки</h1>
      <div className={styles.yourTicketsContent} ref={contentRef}>
        {purchasedTickets.length > 0 ? (
          <TicketsList
            propTickets={purchasedTickets}
            setPurchasedTickets={setPurchasedTickets}
            isAuthenticated={isAuthenticated}
            restartAutoScroll={restartAutoScroll}
          />
        ) : (
          <p className={styles.noTicketsMessage}>
            {isAuthenticated
              ? 'Ви ще не придбали жодного квитка.'
              : 'Увійдіть, щоб переглянути квитки!'}
          </p>
        )}
      </div>
    </div>
  );
};

export default YourTicketsContent;

